import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconClose } from '../../../assets/svg/IconClose.svg';
import './index.css';
import { TooltipCC } from 'components/common';
import { convertNameFile, convertTypeFile, downloadFile  } from './function';
import MapIconFile from './MapIconFile';

const ItemFile = ({ file, isFirst, onDeleteFile, isDownload = false }) => {

    const {t} = useTranslation()

    const handleDownloadFile = () => {
        if (isDownload) {
            downloadFile(file)
        } else return;
    };

    return (
        <div
            onClick={handleDownloadFile}
            className={`item-file-container ${onDeleteFile ? '' : 'no-delete'} ${isFirst ? 'first-item-file' : ''}`}
            style={{ cursor: isDownload ? 'pointer' : 'default' }}
        >
            <MapIconFile type={convertTypeFile(file.name)} />
            <TooltipCC title={isDownload ? t('attachFiles.download') + ' ' + file.name : file.name}>
                <span className="file-name">{convertNameFile(file.name)}</span>
            </TooltipCC>
            {onDeleteFile && (
                <TooltipCC title={t('attachFiles.delete')}>
                    <span className="icon-delete-file" onClick={() => onDeleteFile(file.name)}>
                        <IconClose />
                    </span>
                </TooltipCC>
            )}
        </div>
    );
};

export default ItemFile;
